import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '../../services/http.service';
import { DataTableParamComponent } from '../../modules/@datatable/components/datatable-param.component';
import {GoBackButtonService} from '../../services/go-back-button.service';

@Component({
    selector: 'app-subagent-status',
    templateUrl: './subagent-status.component.html',
    styleUrls: ['./subagent-status.component.scss'],
    standalone: false
})
export class SubagentStatusComponent extends DataTableParamComponent implements OnInit, OnDestroy {

  @Input() public type = 'physical'; // physical or organisation
  @Input() public id: any;

  public physical: any;
  public organisations: any;

  constructor(public http: HttpClient,
              public route: ActivatedRoute,
              public router: Router,
              public goBack: GoBackButtonService) {
    super(http, route, router);
  }

  ngOnInit() {
    this.http.post('Subagent.status',
      {'type': this.type, 'id': this.id}
    ).subscribe(
      data => {
        this.physical = data.physical;
        this.organisations = data.organisations;
      },
      _ => {}
    );
  }

  ngOnDestroy() {
  }
}
